import script from "./thinking-block.vue?vue&type=script&setup=true&lang=js"
export * from "./thinking-block.vue?vue&type=script&setup=true&lang=js"

import "./thinking-block.vue?vue&type=style&index=0&id=435ca915&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-435ca915"]])

export default __exports__